import _slicedToArray from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import React, { useState } from 'react';
import { observer } from 'mobx-react';
import { IconButton, Paper } from '@mui/material';
import Menu from '@jbrowse/core/ui/Menu';
// icons
import ZoomIn from '@mui/icons-material/ZoomIn';
import ZoomOut from '@mui/icons-material/ZoomOut';
import ArrowDown from '@mui/icons-material/KeyboardArrowDown';
var MiniControls = observer(function (props) {
  var model = props.model;
  var bpPerPx = model.bpPerPx,
    maxBpPerPx = model.maxBpPerPx,
    minBpPerPx = model.minBpPerPx,
    scaleFactor = model.scaleFactor,
    hideHeader = model.hideHeader;
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    anchorEl = _useState2[0],
    setAnchorEl = _useState2[1];
  return hideHeader ? React.createElement("div", {
    style: {
      position: 'absolute',
      right: '0px',
      zIndex: '1001'
    }
  }, React.createElement(Paper, {
    style: {
      background: '#aaa7'
    }
  }, React.createElement(IconButton, {
    onClick: function onClick(event) {
      return setAnchorEl(event.currentTarget);
    }
  }, React.createElement(ArrowDown, {
    fontSize: "small"
  })), React.createElement(IconButton, {
    "data-testid": "zoom_out",
    onClick: function onClick() {
      return model.zoom(bpPerPx * 2);
    },
    disabled: bpPerPx >= maxBpPerPx - 0.0001 || scaleFactor !== 1
  }, React.createElement(ZoomOut, {
    fontSize: "small"
  })), React.createElement(IconButton, {
    "data-testid": "zoom_in",
    onClick: function onClick() {
      return model.zoom(model.bpPerPx / 2);
    },
    disabled: bpPerPx <= minBpPerPx + 0.0001 || scaleFactor !== 1
  }, React.createElement(ZoomIn, {
    fontSize: "small"
  })), React.createElement(Menu, {
    anchorEl: anchorEl,
    open: Boolean(anchorEl),
    onMenuItemClick: function onMenuItemClick(_, callback) {
      callback();
      setAnchorEl(undefined);
    },
    onClose: function onClose() {
      return setAnchorEl(undefined);
    },
    menuItems: model.menuItems()
  }))) : null;
});
export default MiniControls;